import Dialog from '#lib/components/dialog.jsx';
import { useAddressAutocomplete } from '#lib/hooks/use-open-route-api.js';
import { AddressAutocomplete } from '#lib/components/address-autocomplete.jsx';
import Button from '#lib/components/button.jsx';
import Input from '#lib/components/input.jsx';
import { Icon } from '@iconify-icon/react';

export function AddressModal(props) {
    const { isOpen, onClose, type, defaultQuery, defaultAddress, defaultCity, defaultPhone, onChange } = props;

    const { options, query, address, city, phone, geometry, handleChangeQuery, handleSetValue } =
        useAddressAutocomplete({
            defaultQuery,
            defaultAddress,
            defaultCity,
            defaultPhone
        });

    const handleSubmit = () => {
        onChange({
            target: { name: type === 'activity' ? 'meetingPoint' : 'address', value: address ?? '' }
        });
        onChange({ target: { name: 'city', value: city } });
        if (type === 'accommodation' && phone) onChange({ target: { name: 'phoneNumber', value: phone } });
        if (type === 'suggestion' && geometry) onChange({ target: { name: 'geometry', value: geometry } });
        onClose();
    };

    return (
        <Dialog isOpen={isOpen}>
            <Dialog.Panel static className={`flex flex-col gap-4 min-w-[300px] w-full max-w-[500px]`}>
                {/* HEADER */}
                <div className="pr-8">
                    <Dialog.CloseButton onClick={onClose} />
                    <div className="flex gap-2">
                        <Icon icon="eva:pin-outline" width="1.2rem" height="1.2rem" />
                        <b>{_t.edit.mapModalTitle()}</b>
                    </div>
                    <p className="pr-2 pt-2 mt-1 text-sm">{_t.edit.mapModalSubTitle()}</p>
                </div>

                {/* BODY */}
                <AddressAutocomplete
                    autoFocus={!!defaultQuery}
                    type={type}
                    query={query}
                    handleChangeQuery={handleChangeQuery}
                    handleSetValue={handleSetValue}
                    options={options}
                />

                <Input.Full
                    label={type === 'activity' ? _t.edit.fields.meetingPoint() : _t.edit.fields.address()}
                    value={address}
                    className="w-full"
                    readOnly={true}
                    disabled={true}
                />
                {type !== 'suggestion' && (
                    <Input.Full
                        label={_t.edit.fields.city()}
                        value={city}
                        className="w-full"
                        readOnly={true}
                        disabled={true}
                    />
                )}
                {type === 'accommodation' && (
                    <Input.Full
                        label={_t.edit.fields.phoneNumber()}
                        value={phone}
                        className="w-full"
                        readOnly={true}
                        disabled={true}
                    />
                )}

                {/* FOOTER */}
                <div className="flex justify-end gap-2 mt-1">
                    <Button type="submit" onClick={onClose}>
                        {_t.global.cancel()}
                    </Button>
                    <Button look="primary" type="submit" onClick={handleSubmit}>
                        {_t.global.confirm()}
                    </Button>
                </div>
            </Dialog.Panel>
        </Dialog>
    );
}
